import { UserAvatarStack } from 'app/components/access-sharing';
import { Radio } from 'app/components/form-fields';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  fleet: any;
  checked: boolean;
  handleCheck: () => void;
};

export default function FleetRadioItem({ fleet, checked, handleCheck }: Props) {
  const { t } = useTranslation();
  const { exposedId } = fleet.sharedItemDetails;

  return (
    <li className="fleet-select__item">
      <Radio
        name="fleet-select"
        checked={checked}
        id={exposedId}
        value={exposedId}
        onChange={handleCheck}
      />

      <label htmlFor={exposedId} className="fleet-info">
        <span
          className={clsx('fleet-select__title ellipsis', {
            'fleet-select__title_checked': checked,
          })}
        >
          {fleet.sharedItemDetails.sharedItemLabel}
        </span>

        <span className="fleet-select__description">
          {t('number_of_equipment', {
            numberOfEquipment:
              fleet.sharedItemDetails.exposedEquipmentIds?.length ?? 0,
          })}
        </span>

        <UserAvatarStack users={fleet.sharedWith} />
      </label>
    </li>
  );
}
